<kendo-card>
    <kendo-card-header>
        <h1 kendoCardTitle>{{'idleAlertTitle' | translate}}</h1>
    </kendo-card-header>
    <kendo-card-body>
        {{'idleAlertMsg' | translate}}
    </kendo-card-body>
    <kendo-card-actions  orientation="horizontal" layout="end">
        <button kendoButton themeColor="primary" (click)="onAllowClick()">{{'allowBtnTxt' | translate}}</button>
        <button kendoButton (click)="onCloseClick()">{{'denyBtnTxt' | translate}}</button>
    </kendo-card-actions>
</kendo-card>